import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const CommonWrapper = createComponent('div', {
  className: 'grid gap-xl'
});

export const Label = createComponent<
  ElementWithProps<{ hasDescription?: boolean }>
>('div', ({ hasDescription = false }) => ({
  className: cx(
    'text-text-strong t-label-sm',
    hasDescription ? 'mb-4' : 'mb-xl'
  )
}));

export const Description = createComponent<
  ElementWithProps<{ isLoading?: boolean }>
>('p', ({ isLoading }) => ({
  className: cx('mb-xl text-text-default t-body-sm', {
    'blur-[2px]': isLoading
  })
}));

export const Divider = createComponent('div', {
  className: 'h-[1px] w-full bg-background-muted-subtle'
});
